import { render, staticRenderFns } from "./tab-oneClient.vue?vue&type=template&id=02fdad6c&"
import script from "./tab-oneClient.vue?vue&type=script&lang=ts&"
export * from "./tab-oneClient.vue?vue&type=script&lang=ts&"
import style0 from "./tab-oneClient.vue?vue&type=style&index=0&id=02fdad6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports